import React, { Fragment } from "react";
import styles from "./MainPages.module.css";
import ContactForm from "../Components/Forms/ContactForm";
import hero from "Utils/Assets/Images/Contactus.webp";
import { IContactPageProps } from "@model/MainPages.model";

const ContactPage: React.FC<IContactPageProps> = ({
  address = "Bteghrine, Lebanon",
  email = "info@chimeratech.net",
  phones = ["+961 81 228 114"],
}) => {
  return (
    <section className={styles.contactPage} data-testid="contactus-page">
      <div
        className={styles.contactHero}
        style={{ ["--hero-bg" as any]: `url(${hero})` }}
        role="img"
        aria-label="Customer support person at home, on phone and tablet"
        data-testid="contactus-hero"
      >
        <div className={styles.contactHeroOverlay} />
        <div className={styles.contactHeroContent}>
          <span className={styles.contactHeroKicker}>Get in touch</span>
          <h1 className={styles.contactHeroTitle}>Contact Us</h1>
        </div>
      </div>

      <div className={styles.contactContentWrap}>
        <aside
          className={styles.contactInfoCard}
          aria-labelledby="contact-info-heading"
          data-testid="contactus-info"
        >
          <h2 id="contact-info-heading" className={styles.contactInfoTitle}>
            Contact Us
          </h2>

          {address && (
            <Fragment>
              <div
                className={styles.contactInfoBlock}
                data-testid="contactus-address"
              >
                <div className={styles.contactInfoLabel}>Address</div>
                <a
                  className={styles.links}
                  href="https://www.example.com"
                  target="_blank"
                >
                  <span className={styles.contactInfoValue}>{address}</span>
                </a>
              </div>
              <div className={styles.contactDivider} />
            </Fragment>
          )}

          {email && (
            <Fragment>
              <div
                className={styles.contactInfoBlock}
                data-testid="contactus-email"
              >
                <div className={styles.contactInfoLabel}>Email</div>
                <a href={`mailto:${email}`} className={styles.contactInfoLink}>
                  {email}
                </a>
              </div>
              <div className={styles.contactDivider} />
            </Fragment>
          )}

          {phones?.length > 0 && (
            <div
              className={styles.contactInfoBlock}
              data-testid="contactus-phones"
            >
              <div className={styles.contactInfoLabel}>Phone</div>
              <div className={styles.contactInfoValue}>
                {phones.map((phone, i) => (
                  <a
                    key={i}
                    className={styles.links}
                    href={`tel:${phone}`}
                    target="_blank"
                  >
                    <span>
                      {phone}
                      {i < phones.length - 1 && <br />}
                    </span>
                  </a>
                ))}
              </div>
            </div>
          )}
        </aside>

        <div className={styles.contactFormCard} data-testid="contactus-form">
          <ContactForm />
        </div>
      </div>
    </section>
  );
};

export default ContactPage;
